//# sourceMappingURL=table.mjs.map
/// <reference types="./table.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $document_context from "../../data/docx/document_context.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $paragraph from "../../data/docx/paragraph.mjs";
import * as $text from "../../data/docx/text.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { Ok, Error, toList, prepend as listPrepend, CustomType as $CustomType } from "../../gleam.mjs";

export class Table extends $CustomType {
  constructor(doc_context, tag, rows, metadata) {
    super();
    this.doc_context = doc_context;
    this.tag = tag;
    this.rows = rows;
    this.metadata = metadata;
  }
}
export const Table$Table = (doc_context, tag, rows, metadata) =>
  new Table(doc_context, tag, rows, metadata);
export const Table$isTable = (value) => value instanceof Table;
export const Table$Table$doc_context = (value) => value.doc_context;
export const Table$Table$0 = (value) => value.doc_context;
export const Table$Table$tag = (value) => value.tag;
export const Table$Table$1 = (value) => value.tag;
export const Table$Table$rows = (value) => value.rows;
export const Table$Table$2 = (value) => value.rows;
export const Table$Table$metadata = (value) => value.metadata;
export const Table$Table$3 = (value) => value.metadata;

export class Row extends $CustomType {
  constructor(index, is_header, cells) {
    super();
    this.index = index;
    this.is_header = is_header;
    this.cells = cells;
  }
}
export const Row$Row = (index, is_header, cells) =>
  new Row(index, is_header, cells);
export const Row$isRow = (value) => value instanceof Row;
export const Row$Row$index = (value) => value.index;
export const Row$Row$0 = (value) => value.index;
export const Row$Row$is_header = (value) => value.is_header;
export const Row$Row$1 = (value) => value.is_header;
export const Row$Row$cells = (value) => value.cells;
export const Row$Row$2 = (value) => value.cells;

export class Text extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const CellContent$Text = ($0) => new Text($0);
export const CellContent$isText = (value) => value instanceof Text;
export const CellContent$Text$0 = (value) => value[0];

export class Paragraph extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const CellContent$Paragraph = ($0) => new Paragraph($0);
export const CellContent$isParagraph = (value) => value instanceof Paragraph;
export const CellContent$Paragraph$0 = (value) => value[0];

export class Cell extends $CustomType {
  constructor(index, children, styles, colspan, rowspan) {
    super();
    this.index = index;
    this.children = children;
    this.styles = styles;
    this.colspan = colspan;
    this.rowspan = rowspan;
  }
}
export const Cell$Cell = (index, children, styles, colspan, rowspan) =>
  new Cell(index, children, styles, colspan, rowspan);
export const Cell$isCell = (value) => value instanceof Cell;
export const Cell$Cell$index = (value) => value.index;
export const Cell$Cell$0 = (value) => value.index;
export const Cell$Cell$children = (value) => value.children;
export const Cell$Cell$1 = (value) => value.children;
export const Cell$Cell$styles = (value) => value.styles;
export const Cell$Cell$2 = (value) => value.styles;
export const Cell$Cell$colspan = (value) => value.colspan;
export const Cell$Cell$3 = (value) => value.colspan;
export const Cell$Cell$rowspan = (value) => value.rowspan;
export const Cell$Cell$4 = (value) => value.rowspan;

export class Metadata extends $CustomType {
  constructor(kind) {
    super();
    this.kind = kind;
  }
}
export const Metadata$Metadata = (kind) => new Metadata(kind);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$kind = (value) => value.kind;
export const Metadata$Metadata$0 = (value) => value.kind;

function metadata_decoder() {
  return $decrypt.optional_field(
    "kind",
    $kind.decoder(),
    (kind) => { return $decode.success(new Metadata(kind)); },
  );
}

function cell_content_decoder() {
  return $decrypt.optional_field(
    "type",
    $decode.string,
    (type_) => {
      if (type_ instanceof Some) {
        let $ = type_[0];
        if ($ === "text") {
          let _pipe = $text.decoder();
          return $decode.map(_pipe, (var0) => { return new Text(var0); });
        } else if ($ === "paragraph") {
          let _pipe = $paragraph.decoder();
          return $decode.map(_pipe, (var0) => { return new Paragraph(var0); });
        } else {
          return $decode.failure(
            new Text(new $text.Text("", toList([]))),
            "Expecting text or paragraph",
          );
        }
      } else {
        return $decode.failure(
          new Text(new $text.Text("", toList([]))),
          "Expecting text or paragraph",
        );
      }
    },
  );
}

function cell_decoder() {
  return $decode.field(
    "index",
    $decode.int,
    (index) => {
      return $decode.optional_field(
        "children",
        toList([]),
        $decode.list(cell_content_decoder()),
        (children) => {
          return $decode.optional_field(
            "cell_style",
            toList([]),
            (() => {
              let _pipe = $decode.dict($decode.string, $decode.string);
              return $decode.map(_pipe, $dict.to_list);
            })(),
            (styles) => {
              return $decrypt.optional_field(
                "colspan",
                $decode.int,
                (colspan) => {
                  let colspan$1 = $option.unwrap(colspan, 1);
                  return $decrypt.optional_field(
                    "rowspan",
                    $decode.int,
                    (rowspan) => {
                      let rowspan$1 = $option.unwrap(rowspan, 1);
                      return $decode.success(
                        new Cell(index, children, styles, colspan$1, rowspan$1),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function row_decoder() {
  return $decode.field(
    "index",
    $decode.int,
    (index) => {
      return $decode.optional_field(
        "is_header",
        false,
        $decode.bool,
        (is_header) => {
          return $decode.optional_field(
            "cells",
            toList([]),
            $decode.list(cell_decoder()),
            (cells) => {
              return $decode.success(new Row(index, is_header, cells));
            },
          );
        },
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "doc_context",
    $document_context.decoder(),
    (doc_context) => {
      return $decode.field(
        "html_tag",
        $decode.string,
        (tag) => {
          return $decrypt.optional_field(
            "rows",
            $decode.list(row_decoder()),
            (rows) => {
              let rows$1 = $option.unwrap(rows, toList([]));
              return $decrypt.optional_field(
                "metadata",
                metadata_decoder(),
                (metadata) => {
                  let metadata$1 = $option.unwrap(
                    metadata,
                    new Metadata(new None()),
                  );
                  return $decode.success(
                    new Table(doc_context, tag, rows$1, metadata$1),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

/**
 * A table without any row carries no content and cannot be represented in the
 * editor: the ProseMirror `table` node requires at least one `tableRow`.
 */
export function is_empty(table) {
  return $list.is_empty(table.rows);
}

function row_to_html(row) {
  let index = $a.attribute("data-index", $int.to_string(row.index));
  let _block;
  let $ = row.is_header;
  if ($) {
    _block = $h.th;
  } else {
    _block = $h.td;
  }
  let cell_node = _block;
  return $h.tr(
    toList([index]),
    $list.map(
      row.cells,
      (cell) => {
        let index$1 = $int.to_string(cell.index);
        let index$2 = $a.attribute("data-index", index$1);
        let style = $a.style(cell.styles);
        let colspan_attr = $a.attribute("colspan", $int.to_string(cell.colspan));
        let rowspan_attr = $a.attribute("rowspan", $int.to_string(cell.rowspan));
        return cell_node(
          toList([index$2, style, colspan_attr, rowspan_attr]),
          $list.map(
            cell.children,
            (content) => {
              if (content instanceof Text) {
                let t = content[0];
                return $text.to_html(t);
              } else {
                let p = content[0];
                return $paragraph.to_html(p);
              }
            },
          ),
        );
      },
    ),
  );
}

export function to_html(table) {
  return $bool.lazy_guard(
    is_empty(table),
    $h.none,
    () => {
      let doc_context_attrs = $document_context.to_html_attributes(
        table.doc_context,
      );
      return $h.element(
        table.tag,
        doc_context_attrs,
        (() => {
          let $ = $list.partition(
            table.rows,
            (row) => { return row.is_header; },
          );
          let headers = $[0];
          let body = $[1];
          return $list.filter_map(
            toList([[$h.thead, headers], [$h.tbody, body]]),
            (_use0) => {
              let section = _use0[0];
              let rows = _use0[1];
              return $bool.guard(
                $list.is_empty(rows),
                new Error(undefined),
                () => {
                  return new Ok(
                    section(toList([]), $list.map(rows, row_to_html)),
                  );
                },
              );
            },
          );
        })(),
      );
    },
  );
}

export function to_labelling(table) {
  let _block;
  let _pipe = table.metadata.kind;
  let _pipe$1 = $option.map(_pipe, $kind.to_string);
  let _pipe$2 = $option.map(
    _pipe$1,
    (_capture) => { return $a.attribute("kind", _capture); },
  );
  _block = $option.unwrap(_pipe$2, $a.none());
  let kind = _block;
  let content = to_html(table);
  let index = $int.to_string(table.doc_context.index);
  let index_attr = $a.attribute("data-index", index);
  let attributes = toList([kind, index_attr]);
  return $h.element("document-labeller", attributes, toList([content]));
}

function encode_cell_content(content) {
  if (content instanceof Text) {
    let t = content[0];
    return $text.encode(t);
  } else {
    let p = content[0];
    return $paragraph.encode(p);
  }
}

function encode_cell(cell) {
  return $json.object(
    toList([
      ["index", $json.int(cell.index)],
      ["children", $json.array(cell.children, encode_cell_content)],
      [
        "cell_style",
        (() => {
          let _pipe = cell.styles;
          let _pipe$1 = $list.map(
            _pipe,
            (_capture) => { return $pair.map_second(_capture, $json.string); },
          );
          return $json.object(_pipe$1);
        })(),
      ],
      ["colspan", $json.int(cell.colspan)],
      ["rowspan", $json.int(cell.rowspan)],
    ]),
  );
}

function encode_row(row) {
  return $json.object(
    toList([
      ["index", $json.int(row.index)],
      ["is_header", $json.bool(row.is_header)],
      ["cells", $json.array(row.cells, encode_cell)],
    ]),
  );
}

export function encode(table) {
  return $json.object(
    toList([
      ["type", $json.string("table")],
      ["doc_context", $document_context.encode(table.doc_context)],
      ["html_tag", $json.string(table.tag)],
      ["rows", $json.array(table.rows, encode_row)],
      [
        "metadata",
        $json.object(
          toList([
            [
              "kind",
              $json.nullable(
                table.metadata.kind,
                (k) => { return $json.string($kind.to_string(k)); },
              ),
            ],
          ]),
        ),
      ],
    ]),
  );
}

function flatten_tree(el) {
  if (el instanceof $html_parser.StartElement) {
    let children = $list.flat_map(el.children, flatten_tree);
    return listPrepend(el, children);
  } else {
    return toList([]);
  }
}

/**
 * A `<tr>` is a header row as soon as it holds a `<th>` cell, which is how
 * both `to_html` and the editor render header rows.
 * 
 * @ignore
 */
function is_header_row(tr) {
  if (tr instanceof $html_parser.StartElement) {
    let children = tr.children;
    return $list.any(
      children,
      (cell) => {
        if (cell instanceof $html_parser.StartElement) {
          let $ = cell.name;
          if ($ === "th") {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
    );
  } else {
    return false;
  }
}

export function from_html(html) {
  let _block;
  let $ = $string.starts_with(html, "<");
  if ($) {
    _block = html;
  } else {
    _block = ("<table>" + html) + "</table>";
  }
  let html$1 = _block;
  let _block$1;
  let _pipe = $string.trim(html$1);
  _block$1 = $string.starts_with(_pipe, "<table");
  let is_table = _block$1;
  return $bool.guard(
    !is_table,
    new Error(undefined),
    () => {
      let root = $html_parser.as_tree(html$1);
      let doc_context = $document_context.from_html_attributes(root);
      let root$1 = flatten_tree(root);
      let trs = $list.filter_map(
        root$1,
        (el) => {
          if (el instanceof $html_parser.EmptyElement) {
            return new Error(undefined);
          } else if (el instanceof $html_parser.StartElement) {
            let $1 = el.name;
            if ($1 === "tr") {
              return new Ok(el);
            } else {
              return new Error(undefined);
            }
          } else if (el instanceof $html_parser.EndElement) {
            return new Error(undefined);
          } else {
            return new Error(undefined);
          }
        },
      );
      let rows = $list.index_map(
        trs,
        (tr, tr_index) => {
          let _block$2;
          if (tr instanceof $html_parser.EmptyElement) {
            _block$2 = toList([]);
          } else if (tr instanceof $html_parser.StartElement) {
            _block$2 = $list.filter_map(
              tr.children,
              (cell) => {
                if (cell instanceof $html_parser.EmptyElement) {
                  return new Error(undefined);
                } else if (cell instanceof $html_parser.StartElement) {
                  let $1 = cell.name;
                  if ($1 === "td") {
                    let _block$3;
                    let _pipe$1 = $html_parser.extract_attribute(
                      "data-index",
                      cell,
                    );
                    let _pipe$2 = $result.try$(_pipe$1, $int.parse);
                    _block$3 = $result.unwrap(_pipe$2, tr_index);
                    let index = _block$3;
                    let children = $list.filter_map(
                      cell.children,
                      (el) => {
                        let _pipe$3 = $paragraph.from_element(el);
                        return $result.map(
                          _pipe$3,
                          (var0) => { return new Paragraph(var0); },
                        );
                      },
                    );
                    let _block$4;
                    let _pipe$3 = $html_parser.extract_attribute(
                      "colspan",
                      cell,
                    );
                    let _pipe$4 = $result.try$(_pipe$3, $int.parse);
                    let _pipe$5 = $option.from_result(_pipe$4);
                    _block$4 = $option.unwrap(_pipe$5, 1);
                    let colspan = _block$4;
                    let _block$5;
                    let _pipe$6 = $html_parser.extract_attribute(
                      "rowspan",
                      cell,
                    );
                    let _pipe$7 = $result.try$(_pipe$6, $int.parse);
                    let _pipe$8 = $option.from_result(_pipe$7);
                    _block$5 = $option.unwrap(_pipe$8, 1);
                    let rowspan = _block$5;
                    let _block$6;
                    let _pipe$9 = $html_parser.extract_attribute("style", cell);
                    let _pipe$10 = $result.map(
                      _pipe$9,
                      $paragraph.parse_style_attribute,
                    );
                    _block$6 = $result.unwrap(_pipe$10, toList([]));
                    let styles = _block$6;
                    return new Ok(
                      new Cell(index, children, styles, colspan, rowspan),
                    );
                  } else if ($1 === "th") {
                    let _block$3;
                    let _pipe$1 = $html_parser.extract_attribute(
                      "data-index",
                      cell,
                    );
                    let _pipe$2 = $result.try$(_pipe$1, $int.parse);
                    _block$3 = $result.unwrap(_pipe$2, tr_index);
                    let index = _block$3;
                    let children = $list.filter_map(
                      cell.children,
                      (el) => {
                        let _pipe$3 = $paragraph.from_element(el);
                        return $result.map(
                          _pipe$3,
                          (var0) => { return new Paragraph(var0); },
                        );
                      },
                    );
                    let _block$4;
                    let _pipe$3 = $html_parser.extract_attribute(
                      "colspan",
                      cell,
                    );
                    let _pipe$4 = $result.try$(_pipe$3, $int.parse);
                    let _pipe$5 = $option.from_result(_pipe$4);
                    _block$4 = $option.unwrap(_pipe$5, 1);
                    let colspan = _block$4;
                    let _block$5;
                    let _pipe$6 = $html_parser.extract_attribute(
                      "rowspan",
                      cell,
                    );
                    let _pipe$7 = $result.try$(_pipe$6, $int.parse);
                    let _pipe$8 = $option.from_result(_pipe$7);
                    _block$5 = $option.unwrap(_pipe$8, 1);
                    let rowspan = _block$5;
                    let _block$6;
                    let _pipe$9 = $html_parser.extract_attribute("style", cell);
                    let _pipe$10 = $result.map(
                      _pipe$9,
                      $paragraph.parse_style_attribute,
                    );
                    _block$6 = $result.unwrap(_pipe$10, toList([]));
                    let styles = _block$6;
                    return new Ok(
                      new Cell(index, children, styles, colspan, rowspan),
                    );
                  } else {
                    return new Error(undefined);
                  }
                } else if (cell instanceof $html_parser.EndElement) {
                  return new Error(undefined);
                } else {
                  return new Error(undefined);
                }
              },
            );
          } else if (tr instanceof $html_parser.EndElement) {
            _block$2 = toList([]);
          } else {
            _block$2 = toList([]);
          }
          let cells = _block$2;
          return new Row(tr_index, is_header_row(tr), cells);
        },
      );
      return new Ok(
        new Table(doc_context, "table", rows, new Metadata(new None())),
      );
    },
  );
}

export function update_kind(table, kind) {
  let metadata = new Metadata(new Some(kind));
  return new Table(table.doc_context, table.tag, table.rows, metadata);
}
